import React from 'react'
import PropTypes from 'prop-types'
import ArgosPlusLogo from '@/components/ArgosPlusLogo/ArgosPlusLogo'

const FulfilmentInfoBox = ({ children, className }) => {
  return (
    <div
      className={`ds-flex ds-items-start ds-gap-2 ds-mb-3 ds-border-red ds-border-sm ds-border-solid ds-rounded-[8px] ds-p-2 ${className ||
        ''}`}
    >
      <ArgosPlusLogo className='ds-flex-shrink-0' />
      {children}
    </div>
  )
}

FulfilmentInfoBox.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}

export default FulfilmentInfoBox
